module.exports = __webpack_public_path__ + "img/BackButton.754791b2.svg";